module.exports = __webpack_public_path__ + "static/media/Cactus Girl.13d24ef7.jpg";